// @ts-strict-ignore
import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

import { lotteryApi } from '@/screens/promo-lottery/api/form-request'

import { cartMiddleware } from '@/entities/cart'

import { apiSlice } from '@/shared/api/apiSlice'

import { localStorageMiddleware, mindBoxMiddleware } from './middlewares'
import { orderFlowRootReducer, OrderFlowRootState } from './orderFlowRootReducer'
import { rootReducer, RootState, SharedRootState } from './rootReducer'

export const makeAppRouterStore = (preloadedState?: Partial<SharedRootState>) => {
	return configureStore({
		reducer: rootReducer,
		preloadedState: preloadedState as never,
		middleware: getDefaultMiddleware =>
			getDefaultMiddleware({
				serializableCheck: false
			})
				.concat(localStorageMiddleware)
				.concat(apiSlice.middleware)
				.concat(lotteryApi.middleware)
				.concat(cartMiddleware)
				.concat(mindBoxMiddleware)
	})
}

export const makeOrderFlowStore = (preloadedState?: Partial<OrderFlowRootState>) => {
	return configureStore({
		reducer: orderFlowRootReducer,
		preloadedState: preloadedState as never,
		middleware: getDefaultMiddleware =>
			getDefaultMiddleware({
				serializableCheck: false
			})
				.concat(localStorageMiddleware)
				.concat(apiSlice.middleware)
				.concat(lotteryApi.middleware)
				.concat(cartMiddleware)
				.concat(mindBoxMiddleware)
	})
}

export type AppRouterStore = ReturnType<typeof makeAppRouterStore>
export type OrderFlowStore = ReturnType<typeof makeOrderFlowStore>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
